import { useContext, useEffect, useState } from 'react';
import { TabContext } from '../../../Context/TabContext';
import Inputs from './components/inputs';
import { urls } from './api/urls';
import useHttp from '../../../hooks/use-http';
import CartItem from './components/CartItem';
import { formatPrice } from '../../../../utils/FormatPrice';
import { useTranslation } from 'react-i18next';

const NaruceniDelovi = () => {
  const { t, i18n } = useTranslation();
  const { tabsData, activeComponent } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localIdDok = dataLocal?.data ? dataLocal?.data : {};
  const [stavke, setStavke] = useState([]);
  const { getData, isLoading } = useHttp('');

  const vratiStavke = async () => {
    console.log(localIdDok);
    const config = {
      url: urls.VRATI_STAVKE,
      method: 'POST',
      data: {
        idMasine: localIdDok.id,
        idKupca: +localStorage.idFirme,
      },
    };
    const response = await getData(config);
    // console.log(response);
    if (response) {
      setStavke(response);
    }
  };
  useEffect(() => {
    vratiStavke();
  }, []);
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div style={{ maxWidth: '800px', width: '100%' }}>
        {stavke.length > 0 ? (
          stavke.map((item) => <CartItem key={item.id} item={item} />)
        ) : (
          <div
            style={{
              width: '100%',
              height: '80vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <label style={{ fontSize: '1.5rem' }}>
              {t('titles.noPartsOrdered')}
            </label>
          </div>
        )}
        {/* <div
          style={{
            display: 'flex',
            justifyContent: 'end',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'end',
              flexDirection: 'column',
            }}
          >
            <div>Ukupno</div>
            <div style={{ fontWeight: 'bold' }}>
              {stavke.length > 0 ? formatPrice(stavke[0].suma) : 0}{' '}
              <span style={{ color: 'gray', fontSize: '15px' }}>EUR</span>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default NaruceniDelovi;
